import axios from "axios";

const LOG_ENDPOINT = "/auditoria/automation-log/";
const RECENT_LOGS = new Map();
const THROTTLE_MS = 2000;
const MAX_CACHE_SIZE = 200;

const pruneOldEntries = (now) => {
  if (RECENT_LOGS.size <= MAX_CACHE_SIZE) return;
  for (const [key, ts] of RECENT_LOGS.entries()) {
    if (now - ts > THROTTLE_MS) {
      RECENT_LOGS.delete(key);
    }
    if (RECENT_LOGS.size <= MAX_CACHE_SIZE) break;
  }
};

export const sendAutomationLog = async ({
  token,
  module,
  eventType,
  payload = {},
  source = "frontend",
  consorcioId = null,
  requestId = null,
  throttle = true,
} = {}) => {
  if (!token || !module || !eventType) return null;

  const sanitizedPayload =
    payload && typeof payload === "object" ? payload : { value: payload };
  const key = `${module}:${eventType}:${JSON.stringify(sanitizedPayload)}:${
    consorcioId || ""
  }`;
  const now = Date.now();

  if (throttle) {
    const last = RECENT_LOGS.get(key);
    if (last && now - last < THROTTLE_MS) {
      return null;
    }
  }

  RECENT_LOGS.set(key, now);
  pruneOldEntries(now);

  try {
    await axios.post(
      LOG_ENDPOINT,
      {
        module,
        event_type: eventType,
        payload_json: sanitizedPayload,
        source,
        consorcio: consorcioId,
        request_id: requestId,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
  } catch (err) {
    // Silenciar fallos de logging
  }
  return true;
};

export default sendAutomationLog;
